exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-8b074352] {\n  position: relative;\n}\na[data-v-8b074352]:hover {\n  text-decoration: none;\n}\n", ""]);

// exports
